import AssociationSchoolCard from './AssociationSchoolCard.component';

export default AssociationSchoolCard;